import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/jobCostReport'
import Component from 'components/Reports/JobCostReport'

export default createListViewContainer({ actions, selectors: selectors.jobCostReport })(Component)
